module.exports = __webpack_public_path__ + "img/default-img.b1b413bf.png";